<template>
  <div class="body" id="bj">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div  id="bj">
        <div id="w-center">
          <div class="index_pub_title">
              <p class="pub_d_title">会员中心</p>
              <router-link :to="`/index`" class="pub_duo pub_duo_d">
                 <i class="el-icon-house size-icon"></i> 首页>会员中心
              </router-link>
              <div class="pub_xian"></div>
          </div>
          <div class="h-20"></div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">修改密码</p>
            </div>
            <div class="w-products rihgt Member-right">
              <div class="member-labe" >
                    <div class="root">
                        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                          <!-- <el-form-item label="手机号" prop="tel">
                            <el-input placeholder="请输入手机号" v-model.number="form.tel"></el-input>
                          </el-form-item>
                          <el-form-item label="验证码" prop="验证码" class="code">
                              <el-input v-model="form.sendcode" placeholder="请输入验证码"></el-input>
                              <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false">发送验证码</el-button>
                              <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}</el-button>
                          </el-form-item> -->
                          <el-form-item label="设置新密码" prop="pass">
                            <el-input type="password"  placeholder="请设置新密码" v-model="form.pass" autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="确认密码"  prop="checkPass">
                            <el-input type="password" placeholder="请确认密码" v-model="form.checkPass" autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="primary" @click="onSubmit(form)" size="medium">确定</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
              </div>
              <div class="h-30"></div>

              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>


        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style scoped >
    .DeviceInfo{width: 45%;}
    .DeviceInfo >>> .el-tabs__item {font-size: 14px;}
    .DeviceInfo >>> .el-tabs__active-bar{width: 0 !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;;}
    .DeviceInfo >>> .el-tabs__nav-scroll{width: 84%;float: right;}
    .DeviceInfo >>> .el-button--medium{width: 100%;background: #2c5fab;border-color: #2c5fab;}

    .DeviceInfo >>> .root {width:100vw;display: table-cell;vertical-align: middle;}
    .DeviceInfo >>> .root  form {width: 100%;margin: auto;}
    .DeviceInfo >>> .root  form .code .el-input{width: 66%;border-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-button {background: #f5f7fa;width: 34%;border-top-left-radius: 0px;border-bottom-left-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-input .el-input__inner{border-top-right-radius: 0px;border-bottom-right-radius: 0px;}
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import headfor from '@/components/public/headfor.vue';
import memberleft from '@/components/public/memberleft.vue'


export default{
  data(){
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.form.checkPass !== '') {
            this.$refs.form.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      activeName: 'second',
      name: "Register",
      activeIndex: '3',
      form: {
          tel: '',
          pass:'',
          checkPass:'',
          name:'',
          dwzw:'',
          sendcode: '',
      },
      rules: {
        pass: [
          {  required: true,validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          {  required: true,validator: validatePass2, trigger: 'blur'}
        ],
      },

      Register: {
          tel: '',
          sendcode: '',
          pass:'',
          checkPass:'',
      },
      disabled: false,
      time: 0,
      btntxt: "重新发送",
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Headfor': headfor,
    'Memberleft': memberleft,

  },
  mounted () {
    var that = this;
    // that.$api.post("/Upload/uploadcorda",{}).then(res => {
    //   console.log(res);
    // });
  },
  methods:{

    // 登录提交
    onSubmit(form) {
      console.log(form);

      if(form.checkPass !== form.pass ){
         this.$message.error('俩次密码输入不一样');
         return
      }
      if(form.checkPass =='' ||  form.pass=='' ){
        this.$message.error('请输入密码');
        return
      }
      var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Login/xgmm",{'password':form.checkPass,'userid':userid}).then(res => {
            console.log(res);
            if(res.code==1){
              that.show = false;
              this.$cookieStore.delCookie('userid');
              this.$message({
                message: res.msg,
                type: 'success'
              });
              setTimeout(this.$router.push('/'), 1000);
            }
        })

    },


    //手机验证发送验证码
    sendcode() {
      var that = this;
        const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if (this.form.tel == '') {
           this.$message.error('手机号不能为空');
           return
        }
        if (!reg.test(this.form.tel)) {
              this.$message.error('请输入正确的手机号');
            return
        } else {

            that.$api.post("/upload/zhmmyzm",{'tel':this.form.tel}).then(res => {
                console.log(res);
                 if(res.code == 1){
                   this.$message({
                       message: '发送成功'+res.msg,
                       type: 'success',
                   });
                   this.time = 60;
                   this.disabled = true;
                   this.timer();
                 }else{
                   this.$message.error('发送失败');
                 }
                 this.$cookieStore.setCookie( 'yzms' ,res.msg, 61);
            })




        }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
          this.time--;
          this.btntxt = this.time + "s后重新获取";
          setTimeout(this.timer, 1000);
      }else{
          this.time = 0;
          this.btntxt = "获取验证码";
          this.disabled = false;
      }
    },
  },
 }
</script>



// WEBPACK FOOTER //
// src/components/MemberPassword.vue